var map = {
	"./common/empty.png": 64471,
	"./common/frame-corner-bottom-left.png": 42507,
	"./common/frame-corner-bottom-right.png": 25012,
	"./common/frame-corner-top-left.png": 14189,
	"./common/frame-corner-top-right.png": 94638,
	"./common/gift.png": 95440,
	"./common/hot.gif": 47910,
	"./event/top-bg.png": 12834,
	"./event/top-right.png": 31445,
	"./event/top-shell-bg.png": 11489,
	"./footer/border-body.png": 53413,
	"./footer/border-top.png": 55320,
	"./header/dropdown-arrow.png": 7581,
	"./header/menu-toggle.png": 99258,
	"./header/mobile-arrow.png": 66628,
	"./home/banner-bg.png": 33272,
	"./home/category-favorite.webp": 29424,
	"./home/category-hot-active.png": 46603,
	"./home/category-hot.png": 4038,
	"./home/category-popular.webp": 27461,
	"./home/category-recent-active.png": 34147,
	"./home/category-recent.png": 43822,
	"./home/category-recent.webp": 2903,
	"./home/category-slots.webp": 91413,
	"./home/event-card-corner-bottom-left.png": 43395,
	"./home/event-card-corner-bottom-right.png": 60812,
	"./home/event-card-corner-top-left.png": 86741,
	"./home/event-card-corner-top-right.png": 66902,
	"./home/frame-corner-bottom-left.png": 869,
	"./home/frame-corner-bottom-right.png": 48614,
	"./home/frame-corner-top-left.png": 23712,
	"./home/frame-corner-top-right.png": 80188,
	"./home/game-section-header-bg.png": 94734,
	"./home/jackpot-bg.png": 29994,
	"./home/notice-icon.webp": 34193,
	"./home/page-bg.png": 82837,
	"./home/redeem-code-icon.png": 78392,
	"./home/search-active.png": 95009,
	"./home/search.png": 45960,
	"./login/exit-confirm-bg.png": 60907,
	"./login/popup-bg.png": 25186,
	"./notification/bg-top1.png": 31294,
	"./person/avatar.png": 72757,
	"./person/bg-vip.png": 16777,
	"./person/bg-vipBottom.png": 7196,
	"./person/bg-vipPc.png": 97490,
	"./person/icon-Deposit.png": 87188,
	"./person/icon-DepositVip.png": 78963,
	"./person/icon-History.png": 5126,
	"./person/icon-Install.png": 57555,
	"./person/icon-Notification.png": 9137,
	"./person/icon-Senha.png": 64281,
	"./person/icon-Transaction.png": 94194,
	"./person/icon-Withdraw.png": 6982,
	"./person/icon-arrow.png": 18353,
	"./person/icon-betsVip.png": 98643,
	"./person/icon-exchange.png": 38587,
	"./person/icon-service.png": 53519,
	"./person/icon_Wallet.png": 21717,
	"./person/icon_copy.png": 29417,
	"./person/icon_logout.png": 2360,
	"./person/icon_notification.png": 60915,
	"./person/vip-center-bg.png": 12467,
	"./share/TreasureChest.png": 5794,
	"./share/TreasureLock.png": 68804,
	"./share/TreasureUnLock.png": 22881,
	"./share/bg-shareMoney.png": 71521,
	"./share/bg-sharePeople.png": 95276,
	"./share/bg-top.png": 51049,
	"./share/facebook.png": 73690,
	"./share/icon_fackbook.png": 87252,
	"./share/icon_howShare.png": 34905,
	"./share/icon_ins.png": 7872,
	"./share/icon_inviteDate.png": 80805,
	"./share/icon_telegram.png": 58287,
	"./share/icon_tiktok.png": 68980,
	"./share/icon_whatsapp.png": 76348,
	"./share/icon_x.png": 65552,
	"./share/icon_youtube.png": 95675,
	"./share/invite_banner1.png": 37859,
	"./share/invite_banner2.png": 59528,
	"./share/invite_banner3.png": 7921,
	"./share/invite_banner4.png": 63358,
	"./share/proxy.png": 58864,
	"./share/redemption-code-title.png": 654,
	"./share/share_bg.png": 90887,
	"./share/trumpet.png": 97251,
	"./sidebar/affiliate-active.png": 58217,
	"./sidebar/affiliate.png": 86464,
	"./sidebar/copy.png": 25146,
	"./sidebar/customer-service.png": 24003,
	"./sidebar/hot-bg.png": 80214,
	"./sidebar/invite-free.png": 26903,
	"./sidebar/language-arrow.png": 69883,
	"./sidebar/menu-item-border.png": 23011,
	"./sidebar/path-arrow.png": 73288,
	"./sidebar/promotion-active.png": 18563,
	"./sidebar/promotion.png": 27374,
	"./sidebar/redemption-code-active.png": 44095,
	"./sidebar/redemption-code.png": 77618,
	"./sidebar/refresh.png": 30652,
	"./sidebar/share-panel-bg.png": 80869,
	"./sidebar/sidebar-border.png": 82702,
	"./sidebar/social-media-active.png": 73308,
	"./sidebar/social-media.png": 6519,
	"./sidebar/telegram.gif": 39671,
	"./sidebar/vip-active.png": 15769,
	"./sidebar/vip-badge.png": 83382,
	"./sidebar/vip.png": 88656,
	"./signIn/suo.png": 61598,
	"./signIn/vipicon.png": 99779,
	"./signIn/vipiconact.png": 70111,
	"./tabbar/active-corner-bottom-left.png": 83949,
	"./tabbar/active-corner-bottom-right.png": 3758,
	"./tabbar/active-corner-top-left.png": 43243,
	"./tabbar/active-corner-top-right.png": 7892,
	"./tabbar/affiliate-active.png": 43143,
	"./tabbar/affiliate.png": 42,
	"./tabbar/home-active.png": 7767,
	"./tabbar/home.png": 86138,
	"./tabbar/menu-active.png": 64551,
	"./tabbar/menu.png": 77962,
	"./tabbar/profile-active.png": 54953,
	"./tabbar/profile.png": 78816,
	"./tabbar/sport.png": 40385,
	"./tabbar/vip-active.png": 97627,
	"./tabbar/vip.png": 79830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54183;